import { ModelType } from "./__generated__/GeneralTaskPageQuery.graphql";

export type GeneralTaskParams = {
  id: string;
  tab: string;
};

export type GeneralTaskKeyValueListPairs = readonly (
  | {
      readonly k: string | null | undefined;
      readonly v: readonly (string | null | undefined)[] | null | undefined;
    }
  | null
  | undefined
)[];

export type SweepArgument =
  | {
      readonly k: string | null | undefined;
      readonly v: readonly (string | null | undefined)[] | null | undefined;
    }
  | null
  | undefined;

export type SweepArguments = readonly (SweepArgument | null)[];

export type TableType =
  | "GENERAL"
  | "HAZARD_GRIDDED"
  | "HAZARD_SITES"
  | "MFD_CURVES"
  | "MFD_CURVES_V2"
  | "%future added value";

export type EventResult = "FAILURE" | "PARTIAL" | "SUCCESS" | "UNDEFINED" | "%future added value";

export type EventState = "DONE" | "SCHEDULED" | "STARTED" | "UNDEFINED" | "%future added value";

export interface ValidatedChildren {
  data?: {
    __typename: string;
    id: string;
    created: unknown;
    duration: number;
    state: EventState;
    result: EventResult;
    arguments: ReadonlyArray<
      | {
          readonly k: string | null | undefined;
          readonly v: string | null | undefined;
        }
      | null
      | undefined
    >;
    inversion_solution?: {
      readonly __typename: string;
      readonly id?: string | undefined;
      readonly mfd_table?: { readonly id: string } | null | undefined;
    };
    rupture_set?: {
      readonly id: string;
      readonly meta?: Meta;
    };
  }[];
}

export interface FilteredArgument {
  k: string;
  v: string[];
}

export interface FilteredArguments {
  data: {
    k: string;
    v: string[];
  }[];
}

export enum ViewTypeEnum {
  Report,
  Image,
}

export interface SolutionDiagnosticsOption {
  id?: string; // stable identity, independent of the filename
  viewType: ViewTypeEnum;
  displayName: string;
  finalPath: string; // either a hash location, or a filepath/name# must be unique
  fallbackPaths?: string[]; // older filenames, tried in order when finalPath 404s
  imgWdth: number | undefined;
  imgHght: number | undefined;
}

export type Meta =
  | readonly (
      | {
          readonly k: string | null | undefined;
          readonly v: string | null | undefined;
        }
      | null
      | undefined
    )[]
  | null
  | undefined;

export enum UnifiedInversionSolutionType {
  SCALED_INVERSION_SOLUTION,
  INVERSION_SOLUTION,
  TIME_DEPENDENT_SOLUTION,
}

export type SourceSolution = {
  id: string;
  meta: Meta;
};

//Common inversion solution for flipchart - accomadates both scaled and normal
export type UnifiedInversionSolution = {
  type: UnifiedInversionSolutionType;
  id: string;
  solution: {
    inversion_id: string;
    meta: Meta;
    hazardId: string | null | undefined;
    mfdTableId: string | null;
    source_solution: SourceSolution | null;
  };
};

export type IStables = ReadonlyArray<{
  readonly table_id: string | null;
  readonly table_type: TableType | null;
} | null> | null;

export interface ClipBoardObject {
  filter: FilteredArguments;
  showList: boolean;
  showFilter: boolean;
  generalViews: string[];
  namedFaultsView: string;
  namedFaultsLocations: string[];
  regionalViews: string[];
  reportTab: number;
  parentFaultViews: string[];
  parentFault: string;
}

export type MetaArguments =
  | ({
      readonly k: string | null | undefined;
      readonly v: string | null | undefined;
    } | null)[]
  | null
  | undefined;

export type GeneralTaskDetails = {
  readonly __typename: "GeneralTask";
  readonly argument_lists:
    | ReadonlyArray<
        | {
            readonly k: string | null | undefined;
            readonly v: ReadonlyArray<string | null | undefined> | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly created: any | null | undefined;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly model_type: ModelType | null | undefined;
  readonly notes: string | null | undefined;
  readonly swept_arguments: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly title: string | null | undefined;
} | null;
